export default {
	ITEM_ADD_SUCCESS: 'Se ha añadido el artículo al carro.',
	ViewCart: 'Ver carro',
	COPY_CART_SUCCESS: 'Pedido añadido al carro.',
	RecurringOrderCancelled: 'El pedido se ha cancelado correctamente.',
	ADD_ADDRESS_SUCCESS: 'Se ha añadido su nueva dirección "{{0}}" correctamente',
	EDIT_ADDRESS_SUCCESS: 'Se ha actualizado su dirección "{{0}}" correctamente',
	DELETE_ADDRESS_SUCCESS: 'Se ha eliminado su dirección "{{0}}" correctamente',
	RESEND_VERIFICATION_CODE:
		'Se ha enviado el código de verificación a su dirección de correo electrónico correctamente.',
	PASSWORD_RESET_SUCCESS: 'Se ha restablecido la contraseña correctamente',
	CREATE_CHECKOUT_PROFILE_SUCCESS: 'Se ha creado correctamente el perfil de pago "{{0}}"',
	COPY_ORDER_SUCCESS: 'Pedido copiado correctamente.',
	CREATE_ORDER_SUCCESS: 'Pedido "{{0}}" creado correctamente.',
	DELETE_ORDER_SUCCESS: 'Pedido "{{0}}" eliminado correctamente.',
	CREATE_REQUISITIONLIST_SUCCESS: 'Lista "{{0}}" creada correctamente.',
	DELETE_REQUISITIONLIST_SUCCESS: 'Lista "{{0}}" eliminada correctamente.',
	UPDATED_REQUISITIONLIST_SUCCESS: 'Los cambios se realizaron correctamente',
	DeletedCheckoutProfile: 'Se ha eliminado correctamente el perfil de pago "{{ 0 }}"',
	UpdatedCheckoutProfile: 'Se ha actualizado correctamente el perfil de pago "{{ 0 }}"',
	deletedSuccessfully: 'Se ha eliminado correctamente {{ n }} artículo del pedido',
	deletedSuccessfully_plural: 'Se han eliminado correctamente {{ n }} artículos del pedido',
	addedItemSuccessfully: '{{ v }} se ha añadido correctamente al pedido actual',
	addedNSuccessfully: 'Se han añadido {{ v }} artículos correctamente al pedido actual',
	addedItemRLSuccessfully: '{{ v }} se ha añadido correctamente al carrito',
	addedNRLSuccessfully_plural: 'Se han añadido correctamente {{ v }} artículos al carrito',
	addedNRLSuccessfully: 'Se ha añadido correctamente {{ v }} artículo al carrito',
	deletedItemListSuccessfully: 'Se ha eliminado correctamente {{ count }} artículo de la lista',
	deletedItemListSuccessfully_plural:
		'Se han eliminado correctamente {{ count }} artículos de la lista',
	CREATE_WISHLIST_SUCCESS: 'La nueva lista de deseos "{{0}}" se ha creado correctamente',
	DELETE_WISHLIST_SUCCESS: 'La lista de deseos "{{0}}" se ha eliminado correctamente',
	DELETE_WISHLIST_ITEM_SUCCESS: '"{{0}}" se ha eliminado correctamente de la lista de deseos.',
	DELETE_WISHLIST_ITEMS_SUCCESS:
		'Los artículos "{{0}}" se han eliminado correctamente de la lista de deseos',
	DELETE_SAVED_ITEM_SUCCESS: '"{{0}}" se ha eliminado correctamente de la lista de guardados.',
	DELETE_SAVED_ITEMS_SUCCESS:
		'Los artículos "{{0}}" se han eliminado correctamente de la lista de guardados.',
	WISHLIST_ADD_SUCCESS: 'El artículo se ha añadido correctamente a la lista "{{0}}"',
	addItemListSuccessfully: '{{ v }} se ha añadido correctamente a la lista',
	addNItemsSuc: 'Se han añadido correctamente {{ n }} artículos a la lista',
	UPDATE_WISHLIST_NAME_SUCCESS: 'El nombre de la lista de deseos se ha actualizado a "{{0}}"',
	ITEM_TO_CART: '"{{ 0 }}" se ha añadido correctamente al carrito',
	ITEMS_N_TO_CART: 'Se han añadido correctamente {{ 0 }} artículos al carrito',
	CopyOrder: 'El pedido se ha añadido al carrito. <0>Ver carrito</0>.',
	PartialCopyOrder:
		'Los productos que están actualmente disponibles para comprar se han añadido al carrito de la compra. <0>Ver carrito</0>.',
	userAccountEnabled: 'Cuenta de usuario "{{ logonId }}" habilitada.',
	userAccountDisabled: 'Cuenta de usuario "{{ logonId }}" inhabilitada.',
	userPasswordReset:
		'Se ha completado el restablecimiento de la contraseña de la cuenta de usuario "{{ logonId }}".',
	BUYER_APPROVAL_APPROVE_SUCCESS: 'Comprador aprobado',
	BUYER_APPROVAL_REJECT_SUCCESS: 'Comprador rechazado',
	ORDER_APPROVAL_APPROVE_SUCCESS: 'Pedido aprobado',
	ORDER_APPROVAL_REJECT_SUCCESS: 'Pedido rechazado',
};
